














export default {
    name: 'EditorInput',

    props: {
        label: {
            type: String,
            required: false,
            default: null,
        },

        placeholder: {
            type: String,
            default: '',
        },

        value: {
            type: String,
            default: '',
        },

        optional: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    setup() {
        const editor = ref(null);
        return {
            editor,
        };
    },

    async mounted() {
        if (process.client) {
            let Quill = require('quill');
            let Delta = Quill.import('delta');
            require('quill/dist/quill.snow.css');
            require('quill/dist/quill.core.js');

            this.editor = new Quill(this.$refs.editor, {
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline'],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        [{ indent: '-1' }, { indent: '+1' }],
                        ['clean'],
                    ],
                    clipboard: {
                        matchers: [
                            [
                                Node.ELEMENT_NODE,
                                function (node, delta) {
                                    return delta.compose(
                                        new Delta().retain(delta.length(), {
                                            color: false,
                                            background: false,
                                        }),
                                    );
                                },
                            ],
                        ],
                    },
                },
                placeholder: this.placeholder,
                theme: 'snow',
            });

            setTimeout(() => {
                this.editor.root.innerHTML = this.value;
            }, 500);

            this.editor.on('text-change', () => {
                // Hide the empty paragraphs to reduce spacing between paragraphs.
                this.editor.root.querySelectorAll('p').forEach((p) => p.innerHTML === '\n\n' && (p.style.display = 'none'));

                this.update();
            });
        }
    },

    methods: {
        update() {
            this.$emit('input', this.editor.root.innerHTML);
        },
    },
};
